import { useEffect, useState } from 'react';
// routes
import Router from './routes';
// theme
import { ThemeConfig } from './theme';
import { GlobalStyles } from './theme/globalStyles';
// components
import { RtlLayout } from './components/RtlLayout';
import { ScrollToTop } from './components/ScrollToTop';
import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// contexts
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import LoadingScreen, { ProgressBarStyle } from './components/LoadingScreen';
import { ThemePrimaryColor } from './components/ThemePrimaryColor';
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------
import { RootStore, RootStoreProvider, setupRootStore } from './models';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from './contexts/JWTContext';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import LoadingCircle from './components/LoadingCircle';

export function App() {
  //
  const [rootStore, setRootStore] = useState<RootStore | undefined>(undefined);
  // Kick off initial async loading actions, like loading fonts and RootStore
  useEffect(() => {
    // mui pro license
    LicenseInfo.setLicenseKey(
      'bd616d3c844e6bfa646b331756ccade3Tz0xMDM0NDgsRT0xNzY0ODM4MjA0MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
    );

    (async () => {
      console.log('APP VERION:', process.env.REACT_APP_VERSION);
      setupRootStore().then(setRootStore);
    })();
  }, []);

  if (!rootStore) {
    return null;
  } else {
    return (
      <RootStoreProvider value={rootStore}>
        <AuthProvider>
          <StrictMode>
            <HelmetProvider>
              <SettingsProvider>
                <CollapseDrawerProvider>
                  <BrowserRouter>
                    <ThemeConfig>
                      <ThemePrimaryColor>
                        <RtlLayout>
                          <SnackbarProvider>
                            <GlobalStyles />
                            <ProgressBarStyle />
                            <ScrollToTop />
                            <Router />
                            <LoadingCircle />
                          </SnackbarProvider>
                        </RtlLayout>
                      </ThemePrimaryColor>
                    </ThemeConfig>
                  </BrowserRouter>
                </CollapseDrawerProvider>
              </SettingsProvider>
            </HelmetProvider>
          </StrictMode>
        </AuthProvider>
      </RootStoreProvider>
    );
  }
}
